import { Component, input, InputSignal } from '@angular/core';
import { Counter } from '../../../../core/interfaces';

@Component({
  selector: 'app-counters',
  imports: [],
  templateUrl: './counters.html',
  styleUrl: './counters.css',
})
export class Counters {
  items: Counter[] = [
    {
      title: '100 Project',
      body: 'Real solutions built for real businesses, from startups to enterprises.',
    },
    {
      title: '10 Industries',
      body: 'We tailor made smart, modern, & scalable solutions to meet your unique needs.',
    },
    {
      title: '5 years',
      body: 'A proven track record in delivering smart, scalable, and advanced digital products.',
    },
  ];
}
